<div class="container">
  <div>
    <button
      *ngFor="let item of activeEvents"
      [disabled]="item.isDisabled"
      (click)="onRegisterOnEventClick(item)"
    >
      {{ item.text }}
    </button>
  </div>
  <div class="jobseeker-profile">
    <div *ngIf="jobseeker?.activationLink" style="text-align: right">
      <button (click)="op.toggle($event)">
        {{ 'label.ActivationLink' | translate }}
      </button>
    </div>
    <p-overlayPanel #op>{{ jobseeker?.activationLink }}</p-overlayPanel>
    <hr-jobseeker-basic
      [jobseeker]="jobseeker"
      (onUpdate)="onJobseekerBasicInfoUpdate($event)"
    ></hr-jobseeker-basic>
    <div>&nbsp;</div>
    <div>
      <p-selectButton
        [options]="switchFilterStates"
        [(ngModel)]="selectedSwitchFilterState"
      ></p-selectButton>
    </div>
    <div>&nbsp;</div>
    <div class="divider hidden-xs"></div>
    <hr-jobseeker-subscription
      [hidden]="selectedSwitchFilterState != switchFilterState.Subscription"
      [jobseeker]="jobseeker"
      [localities]="localities"
      (onUpdate)="load()"
    ></hr-jobseeker-subscription>
    <div [hidden]="selectedSwitchFilterState != switchFilterState.Profile">
      <hr-jobseeker-details
        (onUpdate)="onJobseekerDetailsUpdate($event)"
        [jobseeker]="jobseeker"
        [drivingLicensesInput]="drivingLicensesInput"
        [localities]="localities"
        [monthList]="monthList"
        [yearList]="yearList"
        [genderList]="genderList"
        [locationLevelCount]="locationLevelCount"
        [locationFirstLevelId]="locationFirstLevelId"
        [locationRootId]="locationRootId"
        [jobseekerLocationRequiredLevelCount]="
          jobseekerLocationRequiredLevelCount
        "
        [jobseekerLocationLastHiddenLevelCount]="
          jobseekerLocationLastHiddenLevelCount
        "
      >
      </hr-jobseeker-details>
      <hr-jobseeker-work-experience-info
        [jobseeker]="jobseeker"
        (onUpdate)="onJobseekerWorkExperienceInfoUpdate($event)"
      ></hr-jobseeker-work-experience-info>
      <hr-jobseeker-education-info
        [jobseeker]="jobseeker"
        (onUpdate)="onJobseekerEducationInfoUpdate($event)"
      ></hr-jobseeker-education-info>
      <hr-jobseeker-language-info
        [jobseeker]="jobseeker"
        [worldLanguages]="worldLanguages"
        [languageproficiencyLevelList]="languageproficiencyLevelList"
        (onUpdate)="onJobseekerLanguageInfoUpdate($event)"
      ></hr-jobseeker-language-info>
      <hr-jobseeker-uploaded-document-info
        [jobseeker]="jobseeker"
        (onUpdate)="onJobseekerUploadedDocumentUpdate($event)"
      ></hr-jobseeker-uploaded-document-info>
    </div>
  </div>
</div>
